import { useTranslation } from 'react-i18next';
import { gql, useMutation } from '@apollo/client';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';

import { GET_DOCUMENTS_LABELS_BY_COMPANY } from './get-documents-labels.hook';

export const UPSERT_DOCUMENTS_LABELS = gql`
  mutation upsertDocumentLabels($companyId: String!, $payload: [UpsertDocumentLabelsInput!]!) {
    upsertDocumentLabels(companyId: $companyId, payload: $payload) {
      _id
    }
  }
`;

export const useUpsertDocumentLabels = () => {
  const { t } = useTranslation(['common', 'settings']);
  const [upsertDocumentLabels] = useMutation(UPSERT_DOCUMENTS_LABELS, {
    refetchQueries: [GET_DOCUMENTS_LABELS_BY_COMPANY],
    onError: (error: any) =>
      showNotification({
        type: NOTIFICATION_TYPE.error,
        message: t('common:notifications.error.title'),
        ...(error && { description: error.errorMessage }),
      }),
  });

  return upsertDocumentLabels;
};
